import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const CarditBySendingPostReport = (props) => {
  if (props.userType === 'I') {
    return (
      <Report
        id={props.id}
        tabs={[
          {
            value: ReportDefinitions.CARDIT_BY_SENDING_POST.id,
            label: 'Overview',
          },
          {
            value: ReportDefinitions.CARDIT_BY_SENDING_POST_NUMBERED.id,
            label: '123',
          },
        ]}
        className="carditBySendingPostReport"
        {...props}
      />
    );
  }
  return (
    <Report
      id={props.id}
      tabs={[
          {
            value: ReportDefinitions.CARDIT_BY_SENDING_POST.id,
            label: 'Overview',
          },
        ]}
      className="carditBySendingPostReport"
      {...props}
    />
  );
};

export default CarditBySendingPostReport;

CarditBySendingPostReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  userType: PropTypes.string,
};
